import { FC } from 'react';
import { AllieSelect } from '../../../components';
import { StyledFilterBarMobileContainer } from '../FilterBar/FilterBar.styles';
import { getDisplayText } from '../FilterBar/utils';
import { FilterBarPropsV2 } from './FilterBarV2';

const namespace = 'filter-bar-mobile';

export const AllieFilterBarMobileV2: FC<FilterBarPropsV2> = ({
  filters,
  labelAll,
  labelMultiple, // Add this prop
}) => {
  return (
    <StyledFilterBarMobileContainer>
      <div className={`${namespace}__container-item`}>
        {filters.map(({ label, getOptions, component, handleChange, selected, multiple }) => {
          // Add multiple prop
          const options = getOptions?.(labelAll);
          const displayText = getDisplayText(options || [], selected, labelAll, labelMultiple);

          return (
            <div className={`${namespace}__item`}>
              {component || (
                <AllieSelect
                  className={`${namespace}__item__select`}
                  options={options || []}
                  color={{
                    backgroundColor: 'white',
                    allieColor: 'neutral-60',
                  }}
                  selectedText={displayText === labelAll ? label : displayText}
                  selected={selected}
                  placeholder={label}
                  onChange={handleChange}
                  interface="popover"
                  multiple={multiple} // Add this prop
                  interfaceOptions={{
                    // Add this to match desktop
                    arrow: false,
                    size: 'cover',
                  }}
                />
              )}
            </div>
          );
        })}
      </div>
    </StyledFilterBarMobileContainer>
  );
};
